import {
  menuDetailsFragment,
  menuFragment
} from "@saleor/fragments/navigation";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { TypedQuery } from "../queries";
import { MenuDetails, MenuDetailsVariables } from "./types/MenuDetails";
import { MenuList, MenuListVariables } from "./types/MenuList";
import { PageFooter } from "./types/PageFooter";

const menuList = gql`
  ${menuFragment}
  ${pageInfoFragment}
  query MenuList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $sort: MenuSortingInput
  ) {
    menus(
      first: $first
      after: $after
      before: $before
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...MenuFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
    shop {
      navigation {
        main {
          id
        }
        secondary {
          id
        }
        footer {
          id
        }
        newMain {
          id
        }
      }
    }
  }
`;
export const useMenuListQuery = makeQuery<MenuList, MenuListVariables>(
  menuList
);

const menuDetails = gql`
  ${menuDetailsFragment}
  query MenuDetails($id: ID!) {
    menu(id: $id) {
      ...MenuDetailsFragment
    }
    shop {
      navigation {
        footer {
          id
        }
      }
    }
  }
`;
export const MenuDetailsQuery = TypedQuery<MenuDetails, MenuDetailsVariables>(
  menuDetails
);

const footer = gql`
  query PageFooter {
    pageFooter {
      id
      customerService
      wholesaleInquiries
      mediaPlatformText
      paymentMethodText
      # mediaPlatform{
      #   title
      #   url
      # }
      # paymentMethod{
      #   title
      # }
    }
  }
`;

export const usePageFooterQuery = makeQuery<PageFooter, null>(footer);
